import {TechnologicLogRowInterface} from 'src/app/journals/_interfaces/technologic-log-row.interface';

export class InitMobileEventCards {
    static readonly type = '[MobileEvents] InitMobileEventCards';
    constructor(public eventRows: TechnologicLogRowInterface[]) {}
}
